var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.41 76.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5c1e7;}.cls-2{fill:#baa1de;}.cls-3{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.3,63.83a50.7,50.7,0,0,1-5.87,4.69,43.57,43.57,0,0,1-28.57,7.71C23,75.3,12.28,70.16,2.86,61.35A9,9,0,1,1,15.19,48.17C27.27,59.47,43,63.92,54.56,56.24c11.87-7.88,16.62-27.09,9.91-43.86A9,9,0,0,1,81.23,5.67,53,53,0,0,1,68.3,63.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 41.36,
    cy: 37.32,
    r: 12.38,
    transform: "translate(-1.73 2.01) rotate(-2.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 91.03,
    cy: 24.98,
    r: 12.38,
    transform: "translate(-3.02 33.03) rotate(-20.24)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic4);
export default __webpack_public_path__ + "static/media/Pic4.99d964cef9e047ddcca11efc7ea85dac.svg";
export { ForwardRef as ReactComponent };